import { evaluate, ModalContent, ProgressBar, Typography } from "@kyan/ui";

import { LoadingGem } from "#/components/LoadingGem/LoadingGem";
import { formatValue } from "#/utils/valueFormatters";

import { type TxModalVariant } from "../../EquityModal.types";
import { CountdownClock } from "./components/CountDownClock";

export interface TxPendingModalContentProps {
  variant: TxModalVariant;
  amount?: number;
  progress?: number;
}

export const TxPendingModalContent: React.FC<TxPendingModalContentProps> = ({
  variant,
  amount,
  progress,
}) => {
  const isDeposit = variant === "deposit";

  return (
    <ModalContent
      exitDelay={0.1}
      shouldScroll={false}
      className="h-123.75 max-w-108.25 pt-12"
    >
      <div className="flex flex-col items-stretch">
        <Typography size={24} className="self-center">
          {evaluate({
            "Deposit in progress": isDeposit,
            "Withdrawal in progress": variant === "withdraw",
            "Transfer in progress": variant === "transfer",
          })}
        </Typography>
        <div className="flex h-full flex-col items-center">
          <LoadingGem className="mt-20 mb-10 h-32" />
          <Typography size={24} weight="medium" variant="primary">
            {formatValue(amount || 0, { template: "0 USDC" })}
          </Typography>
          {!isDeposit && (
            <ProgressBar
              max={15}
              className="mt-12"
              template="block 0"
              value={progress ?? 0}
            />
          )}
          {isDeposit && (
            <div className="mt-auto flex flex-col items-center">
              <Typography xs>Estimated time</Typography>
              <CountdownClock seconds={5} />
            </div>
          )}
        </div>
      </div>
    </ModalContent>
  );
};
